export default __webpack_public_path__ + "static/media/mysizeid.8e47a031.png";